import type { BrindeResgatado } from "../../../services/brindesResgatados"

export type { BrindeResgatado }

export type BrindesResgatadosFornecedorModel = {
    brindes: BrindeResgatado[]
    parteNome: string
    email: string
}

export const BrindesResgatadosFornecedorInicial: BrindesResgatadosFornecedorModel = {
    brindes: [],
    parteNome: "",
    email: "",
}
